export const CHART_COLORS = [
  "#2d6be4",
  "#7c3aed",
  "#ea7c2e",
  "#16a34a",
  "#0891b2",
  "#be185d",
];

export const IX_COLOR = "#0d9488";

export const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

export const formatTick = (val: number): string => {
  if (val === 0) return "0";
  if (val >= 1_000_000) {
    const n = val / 1_000_000;
    return `${n % 1 === 0 ? n : n.toFixed(1)}M`;
  }
  if (val >= 1_000) {
    const n = val / 1_000;
    return `${n % 1 === 0 ? n : n.toFixed(1)}K`;
  }
  return `${val}`;
};

export const getYAxis = (max: number): { yMax: number; ticks: number[] } => {
  if (max <= 0) return { yMax: 100, ticks: [0, 25, 50, 75, 100] };
  const rawStep = max / 5;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  // Clamp to at least 1 so ticks are always whole numbers (audience counts are integers)
  const niceStep = Math.max(1, Math.ceil(rawStep / magnitude) * magnitude);
  const yMax = Math.ceil(max / niceStep) * niceStep;
  const ticks: number[] = [];
  for (let v = 0; v <= yMax; v += niceStep) ticks.push(v);
  return { yMax, ticks };
};
